export default {
    API_BASE_URL: "https://api.pickappbasketball.com/v1"
}